import React, { useState } from "react";
import { CheckboxGroup, Checkbox } from "rsuite";

import "./checkboxContent.scss";

const CheckboxContent = ({
  name,
  style,
  type,
  options,
  getAnswerValueByName,
  updateAnswer,
  defaultValue,
}) => {
  const [checkedBox, setCheckedBox] = useState(false);
  return (
    <div className={`${style ? style : ""}`}>
      <CheckboxGroup
        name={name}
        value={
          getAnswerValueByName(name) ? getAnswerValueByName(name) : defaultValue
        }
        className={style}
        style={{ background: "#ffffff" }}
      >
        {options.map((option, optionIndex) => {
          return (
            <Checkbox
              className="d-block"
              style={{
                paddingTop: "0.5rem",
                paddingRight: "1.3rem",
                paddingLeft: "1.2rem",
              }}
              onChange={(value, checked, event) =>
                updateAnswer(event, type, checked)
              }
              value={option.id.toString()}
              key={optionIndex}
            >
              <div
                className={`option-title rs-checkbox-container ${
                  checkedBox ? "rs-checkbox-checked" : ""
                }`}
                onClick={(event) => setCheckedBox(!checkedBox)}
                style={{ margin: "2px", fontWeight: "normal" }}
              >
                {option.title}
              </div>
              <div className="option-content">{option.content}</div>
            </Checkbox>
          );
        })}
      </CheckboxGroup>
    </div>
  );
};

export default CheckboxContent;
